/**
 * Job hand-over formatter (docs/features/shopfloor-kiosk-job-handoff/).
 * `KioskJobOperation.held_by_other` and `.actual_quantity` now come
 * straight off the generated API types (`packages/shared-core/src/data/
 * api-schema.generated.ts`) — the mock-only `heldByOther`/`actualQuantity`
 * type extension this file used to carry has been folded into the real
 * wire shape post-codegen. Only the take-over row's caption formatter
 * remains here.
 */
import type { KioskHeldByOther } from "../data/api-types";

/** The take-over row's caption — "in progress" framing when a quantity was
 * recorded, "not recorded" framing for the walk-away case (product brief
 * Journey 3) — one code path, two readings, matching the spec's decision
 * to fold both into the same take-over screen. */
export function describeHeldByOther(held: KioskHeldByOther): string {
  if (held.last_good_quantity != null) {
    return `In progress · started by ${held.operator_name} · ran ${held.last_good_quantity}`;
  }
  return `started by ${held.operator_name} · quantity not recorded`;
}
